import React, { useEffect, useState } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import { datetimeFormatter } from "../../../utils/datetimeFormatter";
import { Card } from "reactstrap";
import CheckboxYourCases from "../components/CheckboxYourCases";
import {
  setActiveCheckboxes,
  deleteCases,
  openCase,
  getCasesAndProjects,
} from "../../../actions/cases";
import { connect } from "react-redux";
import moment from "moment";

export const YourCases = (props) => {
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [rowData, setRowData] = useState(null);
  const initialHeight = window.innerHeight - 330;

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  useEffect(() => {
    setRowData(props.cases);
    return () => {
      props.setActiveCheckboxes([]);
    };
  }, [props.cases]);

  const getCellStyle = (params) => {
    var style = {};
    style["cursor"] = "default";
    return style;
  };

  return (
    <div style={{ padding: 20 }}>
      <h3 style={{ marginTop: 20, marginBottom: 35 }}>Your cases</h3>
      <div
        style={{
          height: initialHeight,
          width: "100%",
        }}
        className="ag-theme-balham"
      >
        <AgGridReact
          defaultColDef={{
            filter: true,
            filterParams: { buttons: ["reset"] },
            sortable: true,
            resizable: true,
            minWidth: 20,
            maxWidth: 600,
            flex: 1,
            cellStyle: getCellStyle,
          }}
          getContextMenuItems={(params) => [
            "copy",
            "copyWithHeaders",
            "paste",
            "separator",
            {
              name: "Export",
              icon: '<span class="ag-icon ag-icon-save" unselectable="on" role="presentation"></span>',
              subMenu: [
                "csvExport",
                {
                  name: "Excel Export (.xlsx)",
                  icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
                  action: () => {
                    params.api.exportDataAsExcel({ sheetName: "Export" });
                  },
                },
              ],
            },
          ]}
          rowData={rowData}
          rowHeight={24}
          popupParent={document.body}
          suppressDragLeaveHidesColumns={true}
          sideBar={{
            toolPanels: [
              {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel",
              },
            ],
            position: "right",
            defaultToolPanel: null,
          }}
          enableRangeSelection={true}
          frameworkComponents={{
            checkboxComponent: CheckboxYourCases,
          }}
          onGridReady={onGridReady}
        >
          <AgGridColumn
            field="checkbox"
            headerName=""
            filter={false}
            flex={0.1}
            cellRendererSelector={(params) => {
              return { component: "checkboxComponent" };
            }}
          />
          <AgGridColumn
            field="creation_date"
            headerName="Creation date"
            filter={"agDateColumnFilter"}
            valueGetter={(params) => moment(params.data.creation_date)}
            valueFormatter={datetimeFormatter}
          />
          <AgGridColumn field="label" headerName="Label" />
          <AgGridColumn field="project" headerName="Project" />
          <AgGridColumn field="description" headerName="Description" />
          <AgGridColumn field="id" headerName="ID" flex={0.7} hide={true} />
        </AgGridReact>
      </div>
      <Card body style={{ marginTop: 20, border: "1px solid #CCCCCC" }}>
        <div style={{ marginBottom: "15px" }}>
          <h5>Actions:</h5>
        </div>
        <div className="row">
          <div className="col-sm">
            <button
              type="button"
              className="btn btn-success btn-lg btn-block"
              disabled={props.active_checkboxes.length === 1 ? false : true}
              onClick={() => props.openCase(props.active_checkboxes[0])}
            >
              Open
            </button>
          </div>
          <div className="col-sm">
            <button
              type="button"
              className="btn btn-danger btn-lg btn-block"
              disabled={props.active_checkboxes.length >= 1 ? false : true}
              onClick={() =>
                props.deleteCases(
                  props.active_checkboxes,
                  props.getCasesAndProjects,
                  props.id_opened_case
                )
              }
            >
              Delete
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => ({
  cases: state.cases.cases,
  active_checkboxes: state.cases.active_checkboxes,
  id_opened_case: state.analysis.id,
});

export default connect(mapStateToProps, {
  setActiveCheckboxes,
  deleteCases,
  openCase,
  getCasesAndProjects,
})(YourCases);
